import React from 'react';
import { getSiteData } from 'js/services/api';

const DataContext = React.createContext(null);

export const DataProvider = ({ children }) => {
  const [data, setData] = React.useState(false);

  React.useEffect(() => {
    getSiteData()
      .then((res) => {
        setData(res?.payload || {});
      })
      .catch((err) => {
        console.log('There was an err:', err);
      });
  }, []);

  const value = React.useMemo(
    () => ({
      ...data,
    }),
    [data]
  );

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};

export const useData = () => {
  const context = React.useContext(DataContext);

  if (!context) {
    throw new Error('useData must be used within an DataProvider');
  }

  return context;
};
